// @flow
export { default } from './BrandLikeButton';



// WEBPACK FOOTER //
// ./src/components/brand/BrandLikeButton/index.js